export default "__VITE_ASSET__C99cC2D$__"